/**
 * Shared material cache to prevent duplicate texture loading
 * This cache is shared across all components (TexturePreloader, BackendModel, etc.)
 */

// Global cache for loaded material data (textures + properties)
export const materialCache = {};

/**
 * Get cached material data
 * @param {string} materialKey - Material key from materialConfig
 * @returns {Object|null} Cached material data or null if not found
 */
export function getCachedMaterial(materialKey) {
  return materialCache[materialKey] || null;
}

/**
 * Store material data in cache
 * @param {string} materialKey - Material key from materialConfig
 * @param {Object} materialData - Material data (textures, properties, etc.)
 */
export function setCachedMaterial(materialKey, materialData) {
  materialCache[materialKey] = materialData;
}

/**
 * Check if material is cached
 * @param {string} materialKey - Material key from materialConfig
 * @returns {boolean} True if material is in cache
 */
export function isMaterialCached(materialKey) {
  return !!materialCache[materialKey];
}

/**
 * Clear the entire material cache
 */
export function clearMaterialCache() {
  Object.keys(materialCache).forEach(key => {
    delete materialCache[key];
  });
}
